import { gql } from 'apollo-boost';

export const markSingleNotificationViewed = gql`
  mutation markSingleNotificationViewed($notificationId: String!) {
    notificationLog {
      markSingleNotificationViewed(notificationId: $notificationId)
    }
  }
`;

export const markMultipleNotificationsViewed = gql`
  mutation markMultipleNotificationsViewed($notificationIds: [String]!) {
    notificationLog {
      markMultipleNotificationsViewed(notificationIds: $notificationIds)
    }
  }
`;
